"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var formContext_1 = require("../context/formContext");
function useForm(initialValue, name, _type, _message) {
    return getStateAndDispatch(initialValue, name, _type, _message);
}
exports.useForm = useForm;
function getStateAndDispatch(initialValue, name, _type, _message) {
    var form = React.useContext(formContext_1.FormContext);
    if (form.hasProvider) {
        React.useEffect(function () {
            form.update(name, initialValue);
            return function () {
                form.remove(name);
            };
        }, []);
        var setState = function (value) {
            form.update(name, value);
        };
        var type = void 0;
        var message = void 0;
        var state = form.getState();
        var validation = state.messages[name];
        if (validation) {
            type = validation.type;
            message = validation.message;
        }
        return [state.form[name] || '', setState, _type || type, _message || message];
    }
    var _a = React.useState(initialValue), input = _a[0], setInput = _a[1];
    return [input, setInput, _type, _message];
}
